(function CustomerAccount($, HE)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		var navId = '';
		var accountTab = null;

		$('.account-nav').on('click', function storeNavItem() {
			 navId      = $(this).attr('id');
			 accountTab = navId.split('-');
			 localStorage.setItem('accountTab', accountTab[0]);
		});

		HE.onload('Customers/account', function onload()
		{
			var chosenTab = localStorage.getItem('accountTab');
			console.log(chosenTab, 'chosen Tab');

			const triggerEl  = document.querySelector('#'+chosenTab+'-tab');
			const tabTrigger = new bootstrap.Tab(triggerEl);
			tabTrigger.show();

			$('.showPastBooking').on('click', function showPastBooking() {
				$('.past-booking').toggleClass('d-none');
				$('.book-action').toggleClass('d-none');
			});

			$('.reservation').click(function _showConfirmation(e) {
				var reservation_id = $(this).data('reservation-id'),
					$modal         = $(".modal");

				e.preventDefault();

				HE.Ajax.get('/Reservations/view/' + reservation_id).then(function processed(response) {
					$('.modal-dialog').addClass('mw-100 w-75');

					$modal.find('.modal-title').text('Confirmation');
					$modal.find('.modal-body').html(response);
					$modal.modal('show');
				});
			});
		});
	});
}(jQuery, window.HE || {}));